/**
 * AI:
 * Status: 'in progress'
 * Type: Component
 * SubType: ObjectBaseModeComponent
 * Reason: Side view of the bank account overview OBC (`uiMode = 'side' | 'mini-side'`, TM-1000002030).
 *
 *         THE mode of this OBC, not a secondary one: the Abrechnungs-Landkarte (TM-1000002027) opens the
 *         overview in the RIGHT drawer with `uiMode = 'side'`. Everything this view does follows from the
 *         drawer being narrow (it has to stay readable at 40 % drawer width, sibling V-4) and its width and
 *         height belonging to the host:
 *           - the base data run in ONE column and the table on the COMPACT column set (four instead of six:
 *             Abrechnungskonto, Zugeordnet ab, Zugeordnet bis, Status);
 *           - the table brings its own horizontal overflow container, so a row that is still too wide
 *             scrolls INSIDE the drawer instead of pushing it sideways.
 *         Both are decided in {@link CrCustomerBankAccountOverviewComponent} through `[compact]="true"`;
 *         this class only chooses the variant.
 *
 * @ticket TM-1000002030
 */
import {Component, OnInit} from '@angular/core';
import {CrCustomerBankAccountOverviewBaseComponent} from '../base/cr-customer-bank-account-overview-base.component';

@Component({
    selector: 'cr-customer-bank-account-overview-side',
    templateUrl: './cr-customer-bank-account-overview-side.component.html',
    styleUrls: ['./cr-customer-bank-account-overview-side.component.scss'],
    standalone: false
})
export class CrCustomerBankAccountOverviewSideComponent extends CrCustomerBankAccountOverviewBaseComponent
    implements OnInit {

    override ngOnInit(): void {
        super.ngOnInit();
    }

}
